import { memo, FC } from 'react';
import {
  InternalMenuLink,
  MenuItem,
  MenuItemLabel,
} from 'components/BKJMainNavigation/BKJMainNavigation.styled';
import { IInternalMenuLinkProps } from 'components/BKJMainNavigation/BKJMainNavigation.types';
import { NavMenuIcon } from 'components/BKJMainNavigation/src/NavMenuIcon';
import { deepEquals } from 'utils/deepEquals';
import { isCurrentLanguageFrench } from 'providers/i18NextProvider.constants';

const Component: FC<IInternalMenuLinkProps> = (props): JSX.Element => {
  return (
    <InternalMenuLink
      data-cy={props['data-cy']}
      to={props.path}
      $label={props.label}
      $disabled={props.disabled}
      exact={!!props.exact}
      onClick={props.onClick}
      $isOpen={!!props.isOpen}
      aria-current="page"
    >
      <MenuItem>
        <NavMenuIcon iconName={props.icon} color="White" />
        <MenuItemLabel
          $isOpen={props.isOpen}
          $disabled={props.disabled}
          $showPreLine={isCurrentLanguageFrench()}
        >
          {props.label}
        </MenuItemLabel>
      </MenuItem>
    </InternalMenuLink>
  );
};

export const InternalNavMenuItem = memo(Component, deepEquals);
